module.exports = __webpack_public_path__ + "img/wechat-pay.a4b701d9.svg";